module.exports = __webpack_public_path__ + "img/qgjj-07.prt.f8aa02d5.jpg";